module.exports = __webpack_public_path__ + "img/auto-investment-icon.672c2d42.png";